import { createContext } from "react";
import openSocket from "socket.io-client";

// =====================================================================
// SocketContext (S39 fix #47) — versao publica (sem login) do socket.
// Usada pra recursos publicos do CRM. Refatorada pra:
//   - remover transports: ["websocket"] (sem fallback polling = bug)
//   - remover pingTimeout/pingInterval (sao opcoes do SERVER, nao client)
//   - adicionar reconnection options explicitas
//   - adicionar listeners de connect_error/reconnect_failed
// =====================================================================
const socketManager = {
  currentSocket: null,
  currentToken: null,

  GetSocket: function () {
    const publicToken = localStorage.getItem("public-token");

    if (publicToken !== this.currentToken) {
      if (this.currentSocket) {
        try {
          this.currentSocket.removeAllListeners();
          this.currentSocket.disconnect();
        } catch {}
      }

      this.currentToken = publicToken;
      this.currentSocket = openSocket(process.env.REACT_APP_BACKEND_URL, {
        // transports default: ["polling", "websocket"] — polling fallback OK
        reconnection: true,
        reconnectionAttempts: 15, // S53: teto (era Infinity) -> dispara reconnect_failed -> banner
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0.5,
        timeout: 20000,
        query: publicToken ? { token: publicToken } : {}
      });

      this.currentSocket.on("connect_error", (err) => {
        console.warn("[PublicSocket] connect_error:", err && err.message);
      });

      this.currentSocket.on("reconnect_failed", () => {
        console.error("[PublicSocket] reconnect_failed — recarregue a pagina.");
        window.dispatchEvent(new CustomEvent("socket-reconnect-failed"));
      });
    }
    return this.currentSocket;
  },

  onConnect: function (callbackConnect) {
    if (this.currentSocket && this.currentSocket.connected) {
      callbackConnect();
    }
    if (this.currentSocket) {
      this.currentSocket.on("connect", callbackConnect);
    }
  }
};

const SocketContext = createContext();

export { SocketContext, socketManager };
